import { IFetchParams, IFetchResponse } from "@/composables/useFetchWithPagination"
import { http } from "~/utils/axios.util"

export interface IImage {
  alt: string
  url: string
}

export interface ILink {
  url: string
  target: string
  name: string
  rel: string | null
  alt: string | null
}

export enum CardType {
  None,
  ApenABC,
  General,
  NewsArticle,
}

export interface IGeneralOverviewItem {
  id: number
  title: string
  intro: string
  link: ILink
  image?: IImage
  imageMobile?: IImage
  tags?: string[]
  cardType: CardType
}

export interface IApenABCOverviewItem extends IGeneralOverviewItem {
  continents?: string[]
  weight?: string
  iucnStatus?: string
}

export interface INewsOverviewItem extends IGeneralOverviewItem {
  date: string
}

export const OverviewRepository = {
  Get: (params: IFetchParams) =>
    http.get<IFetchResponse<IGeneralOverviewItem>>("/overview/get", {
      params,
    }),
}
